import { Method } from '_lib/api';
import fetchAPI from '_lib/api/fetchWrapper';
import apiRoute from '_lib/api/paths';
import { ToastTitle } from '_store/application/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSaga, SagaType } from 'redux-toolkit-saga';
import { put, select } from 'typed-redux-saga';

import applicationReducer from '../application/reducer';
import manageSpatemRsusFormReducer from '../forms/manage-spatem-rsus';
import { spatemByIdSelector } from './selectors';
import spatemsReducer from './spatemsReducers';
import { SpatemRequestPayload, UpdateSpatemRsusPayload } from './spatemsTypes';

export function* getAllSpatems(action: PayloadAction<SpatemRequestPayload>) {
  const { roadSegmentIds } = action.payload;

  const segments = roadSegmentIds || [];
  const roadSegments = segments.map((id) => `roadSegmentId=${id}`).join('&');

  try {
    const response = yield fetchAPI(apiRoute.spatems(roadSegments));
    const results = response.results || response;
    
    // Transform API response to match expected format
    const transformedResults = Array.isArray(results)
      ? results.map((spatem: any) => {
          // Convert microdegrees to degrees (divide by 1e7)
          const lat = spatem.payload?.coords?.lat ? spatem.payload.coords.lat / 1e7 : 0;
          const lng = spatem.payload?.coords?.long ? spatem.payload.coords.long / 1e7 : 0;
          
          return {
            ...spatem,
            location: {
              type: 'Point' as const,
              coordinates: [lng, lat],
            },
            name: spatem.identifier || spatem.id,
            alive: true, // Default to alive, can be updated based on timestamp if needed
            // Add default distribution for compatibility with CardDetails component
            distribution: {
              kind: 'udp' as const,
              host: '',
              port: 0,
            },
          };
        })
      : [];
    console.log('°^° transformedResults', transformedResults);
    yield* put(spatemsReducer.actions.spatemsResponse(transformedResults));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR getAllSpatems >>>>>>> ', e);
  }
}

export function* updateSpatemRsus(action: PayloadAction<UpdateSpatemRsusPayload>) {
  let toastContent: ToastTitle;
  const { id, identifier, rsus } = action.payload;

  try {
    const saved = yield fetchAPI(apiRoute.updateSpatemRsus(identifier), {
      method: Method.PUT,
      authenticated: true,
      params: { rsus },
    });

    // The next SPATEM brings them too, once spatmap has picked them up
    const spatem = yield* select(spatemByIdSelector(id));
    if (spatem) {
      yield* put(
        spatemsReducer.actions.spatemsUpdate({
          id,
          changes: { payload: { ...spatem.payload, rsus: saved.rsus } },
        }),
      );
    }
    yield* put(manageSpatemRsusFormReducer.actions.resetForm());
    toastContent = { id: 'forms-spatem-update-success', args: { identifier } };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR updateSpatemRsus >>>>>>> ', e);
    toastContent = {
      id: 'forms-spatem-update-fail',
      args: { identifier, error: e?.packet?.message ?? 'Unknown error' },
    };
  } finally {
    yield put(applicationReducer.actions.toastAdded(toastContent));
  }
}

export const spatemsSagas = createSliceSaga({
  name: 'spatems',
  caseSagas: {
    spatemsRequest: getAllSpatems,
    updateSpatemRsus,
  },
  sagaType: SagaType.Watch,
});

